import request from '@/utils/request'

export function getEnteringAndLeaving(params) {
  return request({
    url: '/board/parkCounts',
    method: 'get',
    params,
  })
}
export function getDevice(params) {
  return request({
    url: '/board/deviceCounts',
    method: 'get',
    params,
  })
}
export function getTodayApplication(params) {
  return request({
    url: '/board/todayApplicationCounts',
    method: 'get',
    params,
  })
}
export function getTodayOther(params) {
  return request({
    url: '/board/todayOtherCounts',
    method: 'get',
    params,
  })
}
export function getExceedingTimeLimit(params) {
  return request({
    url: '/board/parkInOutCheckCounts',
    method: 'get',
    params,
  })
}
export function getApplicationCounts(params) {
  return request({
    url: '/board/applicationCounts',
    method: 'get',
    params,
  })
}
export function getDeviceAlarmCounts(params) {
  return request({
    url: '/board/deviceAlarmCounts',
    method: 'get',
    params,
  })
}
